<template>
    <transition name="layout-fade">
        <v-layout wrap>
            <Navigation/>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    import Navigation from './NavigationEnded'

    export default {
        name: 'bookingLayoutNew',
        components: { Navigation }
    }
</script>
